export const LAZY_COMPONENTS = {
    HOW_FIVERR_WORKS: 'how_fiverr_works_de',
    PERSONALIZED_SECTION_WRAPPER: 'personalized_section_wrapper_de',
    FREELANCERS: 'freelancers',
    QUALITY_EXPERTS_BANNER: 'quality_experts_banner',
    KNOWLEDGE_HUB: 'knowledge_hub',
    PRO_BANNER: 'pro_banner',
};
